import api from "./Api";

class AuditoriaService {
  GetAuditoria(payload) {
    return api.get("/v1/auditoria/" + payload).then((response) => {
      return response.data;
    });
  }

  PostAuditoria(payload) {
    return api.post("/v1/auditoria/", payload).then((response) => {
      return response.data;
    });
  }

  PutAuditoria(payload) {
    return api.put("/v1/auditoria/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteAuditoria(payload) {
    return api.delete("/v1/auditoria/" + payload).then((response) => {
      return response.data;
    });
  }

  GetAuditoriaOData(payload) {
    return api.get("/OData/Auditoria" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new AuditoriaService();
